import {notNull} from "./assert";
import type {SlButton} from "@shoelace-style/shoelace/shoelace.js";
import {CookieConsent, getCookieFirst, getCookieFirstInitialConsent} from "./common/cookieFirst";

const cookieConsentLoading = Symbol('cookie_consent_loaded');
type CookieConsentLoading = typeof cookieConsentLoading;

export class ContentConsent extends HTMLElement
{
    private readonly consentCategory: string;
    private readonly consentOverlay: HTMLElement;
    private readonly consentButton: SlButton;
    private readonly gatedContentTemplate: HTMLTemplateElement;
    private cookieConsentValue: CookieConsent|CookieConsentLoading|null = null;
    private rendered = false;

    public constructor()
    {
        super();
        this.consentCategory = notNull(this.dataset.consentCategory);
        this.consentOverlay = notNull(this.querySelector<HTMLElement>('.content-consent__overlay'));
        this.gatedContentTemplate = notNull(this.querySelector<HTMLTemplateElement>('template.content-consent__content'));
        this.consentButton = notNull(this.querySelector<SlButton>('sl-button.content-consent__button'));
        this.consentButton.addEventListener('click', this.onConsentButtonClick.bind(this))
    }

    public connectedCallback() {
        if (this.cookieConsentValue === cookieConsentLoading) {
            return;
        }
        if (this.cookieConsentValue !== null) {
            this.render();
            return;
        }
        this.cookieConsentValue = cookieConsentLoading;
        getCookieFirstInitialConsent().then(cookieConsent => {
            this.cookieConsentValue = cookieConsent;
            if (this.isConnected) {
                this.render();
            }
        });
    }

    private render() {
        if (this.cookieConsentValue === null || this.cookieConsentValue === cookieConsentLoading) {
            throw new Error('Unable to render the content-consent component because the CookieFirst consent is unavailable.');
        }

        if (this.rendered) {
            return;
        }
        this.rendered = true;

        if (this.cookieConsentValue[this.consentCategory]) {
            this.showGatedContent();
        } else {
            this.showGate();
        }
    }

    private async onConsentButtonClick(event: MouseEvent): Promise<void>
    {
        event.preventDefault();
        this.consentButton.loading = true;
        this.consentButton.disabled = true;
        const cookieFirst = await getCookieFirst();
        cookieFirst.acceptCategory(this.consentCategory);
    }

    private showGate(): void
    {
        this.consentOverlay.style.display = '';
    }

    private showGatedContent(): void
    {
        const gatedContent = this.gatedContentTemplate.content.cloneNode(true);
        this.consentOverlay.remove();
        this.appendChild(gatedContent);
    }
}

if (! customElements.get('clx-content-consent')) {
    customElements.define('clx-content-consent', ContentConsent);
}
